module.exports = __webpack_public_path__ + "img/infowar_infowarslife.1614038.png";